import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { AndFilter, ComparisonFilter, IFilter } from "../../components/infrastructure/filtering";
import { Brand } from "../brand";
import { EquipmentItem } from "../equipment/equipmentItem";
import { IEquipmentItemProps } from "../equipment/interfaces";
import { IEquipmentModel, IEquipmentModelProps, IEquipmentModelStates } from "./interfaces";

export class EquipmentModel extends EntityManager<IEquipmentModel, IEquipmentModelProps, IEquipmentModelStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "EquipmentModel",
            title: "مدل تجهیزات",
            Properties: [
                {
                    title: "نوع تجهیز",
                    dataIndex: "EquipmentId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    disable:  (sender: EquipmentModel) =>  (sender.props.isLookupMode || sender.props.isChildComponent) === true,
                    rules: [{ required: true, message: 'لطفانوع تجهیز را وارد نمایید' }],
                    lookup: {
                        lookupComponent: EquipmentItem,
                        lookupProperty: "Equipment",
                        lookupDisplayFields: ["Name"],
                    }
                },
                {
                    title: "برند",
                    dataIndex: "BrandId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    disable: (sender: EquipmentModel) => (sender.props.isLookupMode || sender.props.isChildComponent) === true,
                    rules: [{ required: true, message: 'لطفا برند را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Brand,
                        lookupProperty: "Brand",
                        lookupDisplayFields: ["Name"]
                    }
                },
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "نام لاتین",
                    dataIndex: "NameEn",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "قابلیت تعمیر دارد؟",
                    dataIndex: "IsRepairable",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    width: 150
                }
            ]
        };
    }
    onInitializing() {
        this.searchable = true;
        this.searchArea = { columnsPerRow: 2 };
        this.preparelookupProps = (propName, lookupProps) => {
            if (propName === "EquipmentId")
                (lookupProps as IEquipmentItemProps).params = () => {
                    return { parent: this.props.params && this.props.params()?.equipment };
                };
            return lookupProps;
        }
        this.originalFilter = () => {
            const params = this.props.params && this.props.params();
            const filters: IFilter[] = [];
            if (params?.equipment) {
                filters.push( ComparisonFilter.Equal<IEquipmentModel>(m => m.EquipmentId, params.equipment.Id));
            }
            if (params?.brand) {
                filters.push(ComparisonFilter.Equal<IEquipmentModel>(m => m.BrandId, params.brand.Id));
            }
            if (filters.length > 1)
                return new AndFilter(filters);
            else if (filters.length === 1)
                return filters[0];
        };
        this.onEntityAdded = (entity) => {
            let params = this.props.params && this.props.params();
            if (params?.equipment) {
                entity.EquipmentId = params.equipment.Id;
                entity.Equipment = params.equipment;
                entity.ModifiedProperties.push("EquipmentId");
            }
            if (params?.brand) {
                entity.BrandId = params.brand.Id;
                entity.Brand = params.brand;
                entity.ModifiedProperties.push("BrandId");
            }
            return true;
        };
    }
}